import { Stack, Tooltip, Typography } from "@mui/material";

import type { SvgIconProps, TypographyProps } from "@mui/material";

import type { CarrierStat } from "../../utils";

interface Props extends CarrierStat {
  withDescription: boolean;
  withCounts: boolean;
  iconSize: SvgIconProps["fontSize"];
  textVariant: TypographyProps["variant"];
}

/**
 * Shared scaffolding for a single carrier stat: a tooltip wrapping an icon (or its
 * description label), the stat's value, and an optional count.
 */
export function CarrierStatLabel(props: Props) {
  const {
    tooltip,
    description,
    icon: Icon,
    iconColor,
    value,
    countLabel,
    count,
    withDescription,
    withCounts,
    iconSize,
    textVariant,
  } = props;

  return (
    <Tooltip title={tooltip}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        {withDescription ? (
          <Typography variant={textVariant}>{description}</Typography>
        ) : (
          <Icon fontSize={iconSize} sx={{ color: iconColor }} />
        )}
        <Typography variant={textVariant}>{value}</Typography>
        {withDescription && countLabel !== undefined && (
          <Typography variant={textVariant} color="text.secondary">
            {countLabel}
          </Typography>
        )}
        {!withDescription && withCounts && count !== undefined && (
          <Typography variant={textVariant} color="text.secondary">
            {`(${count})`}
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
}
